import request from '@/plugin/axios'

export function getMemberPageList (query) {
  return request({
    url: '/merbersysapp/memberPageList',
    method: 'post',
    params: query
  })
}
export function getAddressPageList (query) {
  return request({
    url: '/merbersysapp/addressPageList',
    method: 'post',
    params: query
  })
}

export function getCommentPageList (query) {
  return request({
    url: '/merbersysapp/commentPageList',
    method: 'post',
    params: query
  })
}
export function delMembergl (data) {
  return request({
    url: '/merbersysapp/delMembergl',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '删除成功',
        type: 'success'
      }
    }
  })
}

export function delAddress (data) {
  return request({
    url: '/merbersysapp/delAddress',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '删除成功',
        type: 'success'
      }
    }
  })
}

export function delComment (data) {
  return request({
    url: '/merbersysapp/delComment',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '删除成功',
        type: 'success'
      }
    }
  })
}

export function saveMemberCard (data) {
  return request({
    url: '/merbersysapp/MemberSaveCard',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function updateComment (data) {
  return request({
    url: '/merbersysapp/updateComment',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '操作成功',
        type: 'success'
      }
    }
  })
}

export function getAgentXtid (data) {
  return request({
    url: '/moblieapp/getAgentXtid',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function delMemberprice (data) {
  return request({
    url: '/merbersysapp/delMemberprice',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '删除成功',
        type: 'success'
      }
    }
  })
}

export function delMemberglBath (ids) {
  return request({
    url: '/merbersysapp/delMemberglBath',
    method: 'delete',
    params: ids,
    success: {
      type: 'message',
      options: {
        message: '删除成功',
        type: 'success'
      }
    }
  })
}

export function delAddressBath (ids) {
  return request({
    url: '/merbersysapp/delAddressBath',
    method: 'delete',
    params: ids,
    success: {
      type: 'message',
      options: {
        message: '删除成功',
        type: 'success'
      }
    }
  })
}

export function delCommentBath (ids) {
  return request({
    url: '/merbersysapp/delCommentBath',
    method: 'delete',
    params: ids,
    success: {
      type: 'message',
      options: {
        message: '删除成功',
        type: 'success'
      }
    }
  })
}

export function listMemberUser (query) {
  return request({
    url: '/merbersysapp/listMemberUser',
    method: 'post',
    params: query
  })
}

export function listMemberCard (query) {
  return request({
    url: '/merbersysapp/listMemberCard',
    method: 'post',
    params: query
  })
}

export function delMemberpriceBath (ids) {
  return request({
    url: '/merbersysapp/delMemberpriceBath',
    method: 'delete',
    data: ids,
    success: {
      type: 'message',
      options: {
        message: '删除成功',
        type: 'success'
      }
    }
  })
}
